import { Box } from '@apia/theme';
import { MutableRefObject, useContext } from 'react';
import Searchbox from './Searchbox';
import Options from './Options';
import useMultipleRefs from '../../../../hooks/useMultipleRefs';
import { AutocompleteContext } from './AutocompleteContext';
import { TAutocomplete } from './types';
import ColorContext from './ColorContext';

const Body = ({
  mainRef,
  props,
}: {
  mainRef: MutableRefObject<HTMLElement>;
  props: TAutocomplete;
}) => {
  const {
    boxRef,
    keyhandler: { useValue },
    autocompleteBox: { OptionsBox },
  } = useContext(AutocompleteContext);
  const assignRefs = useMultipleRefs(boxRef, mainRef);
  useValue((newValue) => {
    props.onChange?.(newValue);
  });
  return (
    <ColorContext.Provider value={props.color ?? ''}>
      <Box
        ref={assignRefs}
        {...props.containerProps}
        aria-label={undefined}
        id={undefined}
        className={`${props.containerProps?.className ?? ''} autocomplete`}
        variant="layout.common.components.autocomplete"
      >
        <Searchbox
          inputProps={{
            id: props.containerProps?.id ?? '',
            'aria-label': props.containerProps?.['aria-label'],
            ...props.inputProps,
          }}
          showSpinner={props.showSpinner}
        />
        <OptionsBox>
          <Options />
        </OptionsBox>
      </Box>
    </ColorContext.Provider>
  );
};

export default Body;
